<template>
  <BaseDialog
    title="Assigned Pickup Type Order To Ongoing Trip"
    width="90%"
    v-model="openPickupTypeOrderAssignForm"
    :btnEnable="true"
    @reset="resetForm"
  >
    <template #information>
      <v-col
        cols="12"
        v-if="
          formErrors.non_field_errors && formErrors.non_field_errors.length > 0
        "
        class="pt-0"
      >
        <v-alert dense type="error" class="ma-0">
          <v-list
            class="pa-0"
            dense
            style="background: inherit !important"
            v-for="(error, i) in formErrors.non_field_errors"
            :key="i"
          >
            <v-list-item dense style="min-height: 20px !important">
              <span>{{ i }} .</span><span>{{ error }}</span>
            </v-list-item>
          </v-list>
        </v-alert>
      </v-col>
      <br />
      <v-row col="12">
        <v-col cols="4" class="PR-6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span class="text-caption">Trip Reference Number</span>
              </div>
              <p class="text-subtitle-2 primary--text mb-0">
                {{ parentObj?.trip_details?.reference_number }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" class="PR-6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span class="text-caption">Trip Volume </span>
              </div>
              <p class="text-subtitle-2 primary--text mb-0">
                {{ parentObj?.trip_details?.volume }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" class="PR-6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span class="text-caption">Trip Weight</span>
              </div>
              <p class="text-subtitle-2 primary--text mb-0">
                {{ parentObj?.trip_details?.weight }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <ListLayout
        :noMargin="true"
        :hasAfterTitle="false"
        :tableData="pickupTypeOrderList"
        :context="context"
        :tableHeader="tableHeaders"
        :total="totalItems"
        :tableScrollable="true"
        :hasOtherGridOptions="true"
        :otherGridOption="otherGridOption"
        @selectionChanged="selectionChanged"
        @getList="getPickupTypeOrder"
      >
        <template #listAction>
          <PrimaryButton
            id="assign_pickup_type_order_to_ongoing_trip"
            name="Assigned Selected Order To Ongoing Trip"
            icon="mdi-playlist-plus"
            iconSize="x-large"
            v-if="selectedRows.length > 0"
            @click="assignSelectedOrderToOngoingTrip"
          >
          </PrimaryButton>
        </template>
      </ListLayout>
    </template>
  </BaseDialog>
</template>

<script>
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { bus } from "@/main";
import PrimaryButton from "@/components/ComponentLibrary/Buttons/PrimaryButton.vue";

export default {
  components: {
    ListLayout,
    BaseDialog,
    PrimaryButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    parentObj: {
      type: Object,
    },
  },
  data() {
    return {
      pickupTypeOrderList: [],
      selectedRows: [],
      formErrors: {},
      tableHeaders: [
        {
          headerName: "Reference Number",
          field: "reference_number",
          sortable: false,
          pinned: "left",
          minWidth: 200,
          checkboxSelection: true,
        },
        {
          headerName: "Execution Date",
          field: "execution_date",
          sortable: false,
          pinned: "left",
          minWidth: 100,
        },
        {
          headerName: "Status",
          field: "verbose_status",
          sortable: false,
          pinned: "left",
          minWidth: 100,
        },
        {
          headerName: "Weight",
          field: "weight",
          sortable: false,
        },
        {
          headerName: "Volume",
          field: "volume",
          sortable: false,
        },
        {
          headerName: "Customer Name",
          field: "customer_name",
          sortable: false,
        },
        {
          headerName: "Location ID",
          field: "location_id",
          sortable: false,
        },
        {
          headerName: "Total items",
          field: "total_items",
          sortable: false,
        },
        {
          headerName: "Items Storage Types",
          field: "items_storage_types",
          sortable: false,
        },
      ],
      totalItems: null,
      otherGridOption: { rowSelection: "multiple" },
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getPickupTypeOrder();
      } else {
      }
    },
  },
  computed: {
    openPickupTypeOrderAssignForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    resetForm() {
      this.formErrors = {};
      this.selectedRows = [];
    },
    selectionChanged(rowData) {
      this.selectedRows = rowData;
    },
    getPickupTypeOrder(params = {}) {
      params = {
        ...params,
        execution_date: this.parentObj.trip_details.trip_date_for_filter,
        segment: "sales",
        order_type: "pickup",
        status: "unassigned",
      };
      this.$api.orderNew
        .getOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.pickupTypeOrderList = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    assignSelectedOrderToOngoingTrip() {
      const selected_orders_id = this.selectedRows
        .map((obj) => obj.id)
        .join(",");
      bus.$emit("showLoader", true);

      this.$api.trip
        .assignPickupTypeOrderToOngoingTrip(
          this.parentObj.id,
          selected_orders_id
        )
        .then((res) => {
          this.openPickupTypeOrderAssignForm = false;
          bus.$emit("showLoader", false);
          this.$emit("refreshDetailPage");
        })
        .catch((err) => {
          console.log(err);
          this.formErrors = err.data;
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
